export type EnvironmentKind = 'staging' | 'staging_experimental' | 'e2e';

export const getEnvironmentKind = (hostname: string): EnvironmentKind | null => {
  if (/^stg-exp\./.test(hostname)) {
    return 'staging_experimental';
  }
  if (/^stg\d*\./.test(hostname)) {
    return 'staging';
  }
  if (hostname === 'e2e.aitravel.jp' || hostname.startsWith('e2e.') || hostname.includes('.e2e.')) {
    return 'e2e';
  }
  return null;
};

export const getEnvironmentDisplayName = (kind: EnvironmentKind): string => {
  switch (kind) {
    case 'staging_experimental':
      return 'stg-exp環境';
    case 'e2e':
      return 'e2eテスト環境';
    default:
      return 'ステージング環境';
  }
};
